import { useState } from 'react';
import "./Footer.css";
import { AppEnvSetting } from '../ts/common';
import { ContactUs } from '../components/ContactUs';

const Footer = () => {
    // footer class must remain for footer to function properly!
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const bgColor = AppEnvSetting.pallette.primary.main
  function toggleContactUsPopup(e: any) {
    setOpenPopup(!openPopup);
  }

    const color =   AppEnvSetting.pallette.primary.main
    return (
      <>
        <div className="footer customFooter" style={{backgroundColor: color}}>
        {
          AppEnvSetting.showContactUsPage ? <>
            <span className="">If you are having issues, please</span>
            <a href="#" onClick={(e) => toggleContactUsPopup(e)} >Contact Us</a>
          </> : <></>
        }
        </div>
      {
        AppEnvSetting.showContactUsPage ? <ContactUs actionPopup={openPopup} setActionPopup={toggleContactUsPopup} /> : <></>
      }
    </>
    )
}

export default Footer